import { SubjectData } from 'shell/models/person';
import { DateTime } from 'luxon';
import { ActType } from 'shell/constants/act-type';
import { ActManagementForm } from 'shell/view-models/act-form';

export const transformBirthdayAnpr05Document = (
  person: SubjectData
): ActManagementForm | undefined => {
  if (!(person.attoNascitaANPR?.atto || person.attoNascitaANPR?.attoANSC)) {
    return undefined;
  }

  return {
    actType: person.attoNascitaANPR?.attoANSC
      ? ActType.AttoDigitale
      : person.attoNascitaANPR?.atto
      ? ActType.AttoCartaceo
      : ActType.SenzaAtto,
    paper: person.attoNascitaANPR?.attoANSC
      ? undefined
      : {
          actMunicipality: {
            id: person.attoNascitaANPR?.atto?.comuneRegistrazione?.codiceIstat || '',
            description: person.attoNascitaANPR?.atto?.comuneRegistrazione?.nomeComune || '',
            province: person.attoNascitaANPR?.atto?.comuneRegistrazione?.siglaProvinciaIstat || '',
          },
          actYear: person.attoNascitaANPR?.atto?.anno || '',
          actPart: person.attoNascitaANPR?.atto?.parte || '',
          actSeries: person.attoNascitaANPR?.atto?.serie || '',
          actNumber: person.attoNascitaANPR?.atto?.numeroAtto || '',
          actVolume: person.attoNascitaANPR?.atto?.volume || '',
          actDate: person.attoNascitaANPR?.atto?.dataFormazioneAtto
            ? DateTime.fromISO(person.attoNascitaANPR?.atto?.dataFormazioneAtto)
            : null,
          transcribed: person.attoNascitaANPR?.atto?.trascritto === '1' ? true : false,
        },
    digital: person.attoNascitaANPR?.attoANSC
      ? {
          documentDate: person.attoNascitaANPR?.attoANSC?.dataFormazioneAtto
            ? DateTime.fromISO(person.attoNascitaANPR?.attoANSC?.dataFormazioneAtto)
            : null,
          idAnsc: person.attoNascitaANPR?.attoANSC?.idANSC || '',
          istatCode: person.attoNascitaANPR?.attoANSC?.comuneRegistrazione?.codiceIstat || '',
          municipality: {
            id: person.attoNascitaANPR?.attoANSC?.comuneRegistrazione?.codiceIstat || '',
            description: person.attoNascitaANPR?.attoANSC?.comuneRegistrazione?.nomeComune || '',
            province:
              person.attoNascitaANPR?.attoANSC?.comuneRegistrazione?.siglaProvinciaIstat || '',
          },
          numberMunicipality: person.attoNascitaANPR?.attoANSC?.numeroComunale || '',
          year: person.attoNascitaANPR?.attoANSC?.anno || '',
          transcript: person.attoNascitaANPR?.attoANSC?.trascritto === '1' ? true : false,
        }
      : undefined,
  };
};
